export const ACCOUNTS = '/accounts'
